var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.6583 15.9916L23.7478 19.0811C24.1632 19.4965 24.1632 20.1701 23.7478 20.5856C21.5017 22.8317 17.9458 23.0844 15.4047 21.1785L13.5667 19.8C11.5325 18.2744 9.72559 16.4675 8.2 14.4333L6.82151 12.5953C4.91564 10.0542 5.16835 6.49832 7.41444 4.25223C7.82988 3.83678 8.50345 3.83678 8.9189 4.25223L12.0084 7.34171C12.464 7.79732 12.464 8.53601 12.0084 8.99162L10.817 10.183C10.6277 10.3723 10.5808 10.6615 10.7005 10.901C12.0849 13.6699 14.3301 15.9151 17.099 17.2995C17.3385 17.4192 17.6277 17.3723 17.817 17.183L19.0084 15.9916C19.464 15.536 20.2027 15.536 20.6583 15.9916Z",
    stroke: "#1B1836",
    strokeWidth: 1.6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.5e298c4a13914732cfc3f712b0771979.svg";
export { ForwardRef as ReactComponent };